<template lang="pug">
	.online-users-local(v-if="Layout.isFeatureEnabled('online-users')")
		transition(name="user-fade" appear v-for="userData in users")
			.user-content
				.user-photo(v-if="!userData.additionalCount" :style="{backgroundImage: `url(${userData['photo'] || 'Images/Screens/Login/default-user-icon.jpg'})`}")
					.c-avatar-status.bg-success
				.additional-users-count(v-if="userData.additionalCount") ...
</template>

<script>

	import Screen 			from './../../mixins/screen'

	import { Publisher } 	from './../../services/Publisher'
	import { User } 		from './../../services/User'

	export default {
		name: "OnlineUsersLocal",
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Feature Changed", "Users Online Status Changed", "User Online Status Changed", "User Online Status Added", "User Online Status Removed"]
		},
		props: ["filter", "maxCount"],
		data() {

			this.Publisher = Publisher;
			this.User = User;

			this.users = [];

			return {
				showed: true
			}
		},
		methods: {
			collectData() {

				//Убираем из групп пользователей которые уже не онлайн
				this.users = _.filter(User.usersOnlineStatus.Users, userData => this.filter(userData));

				this.users = _.sortBy(this.users, 'userId');

				if (this.maxCount && this.users.length > this.maxCount) {

					let additionalCount = this.users.length - (this.maxCount - 1);

					this.users.length = this.maxCount - 1;

					this.users.push({additionalCount});

				}

			}
		}
	}
</script>

<style lang="sass" scoped>

	.online-users-local
		display: flex
		flex-direction: row
		overflow: visible
		width: 100%
		pointer-events: none

		.user-content
			display: flex
			position: relative
			width: 100%
			max-width: 20px

			.user-photo
				position: absolute
				background: center / auto 100% no-repeat
				width: 15px
				height: 15px
				border-radius: 15px
				cursor: pointer
				top: 0
				left: 0
				z-index: 1

				.c-avatar-status
					width: 5px
					height: 5px
					position: absolute
					bottom: 0
					right: 0
					display: block
					border-radius: 5px

				&.user-fade-enter, &.user-fade-leave-to
					opacity: 0

				&.user-fade-enter-active, &.user-fade-leave-active
					transition: opacity 0.2s

			.additional-users-count
				width: 15px
				height: 15px
				font-size: 12px
				color: rgba(255, 255, 255, 0.5)
				padding-top: 3px

</style>

